export var EVENT_CHANNEL = 'media';